import { FadeIn, MaskedLine } from "@/components/Reveal";

export default function PageHero({ kicker, title, italic, description }) {
  return (
    <section className="mx-auto max-w-7xl px-6 pb-16 pt-40 md:px-12 md:pb-20 md:pt-48">
      <FadeIn>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-forest">{kicker}</p>
      </FadeIn>
      <h1 className="mt-6 font-serif text-5xl leading-[1.05] tracking-tight text-charcoal md:text-7xl">
        <MaskedLine delay={0.1}>{title}</MaskedLine>
        {italic && (
          <MaskedLine delay={0.25}>
            <em className="text-forest">{italic}</em>
          </MaskedLine>
        )}
      </h1>
      {description && (
        <FadeIn delay={0.4} className="mt-8 max-w-2xl">
          <p className="text-base leading-relaxed text-charcoal/70 md:text-lg">{description}</p>
        </FadeIn>
      )}
    </section>
  );
}
